export default {
      id: "layout-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "icons/symbols.67516b0a.svg#layout",
      toString: function () {
        return this.url;
      }
    }